export default "__VITE_ASSET__U4$JVTi$__"